import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s7/b1.jpeg');

class Services_7 extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Visible Warnings. Clear Instructions. Safer Spaces."
            pagename="Signage Works"
            bgimage={bnrimg}
          />

          <div className="section-full p-tb80 inner-page-padding">
            <div className="container">
              <div className="blog-single-wrap-width">
                <div className="blog-post date-style-3 blog-detail text-black">
                  <div className="mt-post-media clearfix m-b30">
                    <ul className="grid-post">
                      <li>
                        <div className="portfolio-item">
                          <img
                            className="img-responsive"
                            src={require("./../../images/s7/b2.jpg")}
                            alt="Safety Signage Installation"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="mt-post-title">
                    <h3 className="post-title font-weight-600">Signage Works</h3>
                  </div>

                  <div className="mt-post-text">
                    <p><strong>“Clear signs save time. Clear time saves lives.”</strong></p>

                    <p>
                      At <strong>I‑Smart Engineering Works</strong>, we engineer and install critical safety and informational signage with military-grade precision. Our signs guide evacuation, mark exits, identify hazards, and ensure quick comprehension for everyone — in every situation.
                    </p>

                    <p>
                      Designed for clarity, durability, and compliance, our signage systems are deployed in commercial buildings, industrial zones, hospitals, and public infrastructure — ensuring every instruction is visible, anytime, anywhere.
                    </p>

                    <h4 className="font-weight-600">Our Signage Services Include:</h4>
                    <ul className="list-angle-right">
                      <li>Fire exit and evacuation route signs (ISO‑compliant)</li>
                      <li>Glow‑in‑the‑dark and photoluminescent emergency markers</li>
                      <li>Hazard and equipment identification plates</li>
                      <li>Custom directional & informational boards</li>
                      <li>Installation, alignment checks & durability inspections</li>
                      <li>AMC for condition monitoring and replacements</li>
                    </ul>

                    <blockquote className="bg-dark text-white author-quote">
                      <h4 className="m-b0">
                        “On the deck or in the corridor, a sign must speak loud, even in silence.” <i className="fa fa-quote-right" />
                      </h4>
                      <div className="p-t15 text-white">
                        <strong className="text-primary">Lt. Commander A. Singh</strong>
                        <span>Navy Safety & Protocol Division</span>
                      </div>
                    </blockquote>

                    <p>
                      Our signs are made with high‑contrast graphics, rugged materials, and tested for long‑term visibility — ensuring clarity under stress. Let us ensure your building “speaks” instructions that everyone can follow.
                    </p>

                    {/* <div className="row">
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog.jpg")} alt="Exit Sign Installation" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog2.jpg")} alt="Photoluminescent Sign" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog3.jpg")} alt="Custom Safety Signs" />
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <p>
                      <strong>Need signage that guides, warns, and protects?</strong> Contact us now for a signage audit and blueprint of your safety communication network.
                    </p>
                  </div>

                  <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="widget widget_tag_cloud">
                          <h4 className="tagcloud">Tags</h4>
                          <div className="tagcloud">
                            <NavLink to="#">Safety Signs</NavLink>&nbsp;
                            <NavLink to="#">Evacuation Markers</NavLink>&nbsp;
                            <NavLink to="#">Emergency Signage</NavLink>&nbsp;
                            <NavLink to="#">Photoluminescent Signs</NavLink>&nbsp;
                            <NavLink to="#">AMC Signage</NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Services_7;
